import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DateTimePipe } from './pipes/date-time.pipe';
import { FileSizePipe } from './pipes/file-size.pipe';
import { AntdModule } from '../Antd.module';
import { HasClickEntitlementDirective } from './directives/has-click-entitlement.directive';
import { HeaderComponent } from './components/header/header.component';
import { LoginComponent } from './components/login/login.component';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TrimFormInputDirective } from './directives/trim-form-input.directive';
import { ResizableColumnDirective } from './directives/resizable-column.directive';
import { LayoutComponent } from './components/layout/layout.component';
import { RedirectComponent } from './components/redirect/redirect.component';
import { AppRoutingModule } from '../app-routing.module';

@NgModule({
  declarations: [DateTimePipe, FileSizePipe, HeaderComponent, LoginComponent, LayoutComponent, RedirectComponent],
  imports: [
    CommonModule,
    AntdModule,
    HasClickEntitlementDirective,
    RouterModule,
    AppRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    TrimFormInputDirective,
    ResizableColumnDirective,
  ],
  exports: [
    DateTimePipe,
    FileSizePipe,
    HasClickEntitlementDirective,
    HeaderComponent,
    LoginComponent,
    TrimFormInputDirective,
    ResizableColumnDirective,
    AntdModule,
  ],
})
export class SharedModule {}
